var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 35,
    viewBox: "0 0 86 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0744 0H42.1438V35H49.0744V0Z",
    fill: "#006F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8854 34.7174H51.6248V27.7445H68.8854C74.5003 27.7445 79.0694 23.1476 79.0694 17.4984C79.0694 11.8492 74.5003 7.25228 68.8854 7.25228H51.6248V0.282619H68.8854C78.3219 0.282619 85.9984 8.00593 85.9984 17.5C85.9984 26.9941 78.3219 34.7174 68.8854 34.7174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0336 22.2534L30.5837 0H22.5216L13.7722 35H21.0869L26.5526 12.6811L32.0184 35H38.0587L39.7631 31.0753V13.6727L36.0336 22.2534Z",
    fill: "#006F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5038 18.6448L7.56382 0.376825H0L12.7772 29.7771L15.5038 18.6448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/c-logo.77a15be05e1cb3c689782d962fd042c7.svg";
export { ForwardRef as ReactComponent };